import { CheckCircle2, Info, MonitorDown, ShieldCheck } from 'lucide-react';
import { useRequiredMe } from '../auth/AuthProvider';
import { Page } from '../components/layout';
import { useT } from '../i18n';
import { isStandalone } from '../lib/standalone';
import { AccountSection } from './settings/AccountSection';
import { CalendarFeedSection } from './settings/CalendarFeedSection';
import { MyAttendanceSection } from './settings/MyAttendanceSection';
import { DrawingSection } from './settings/DrawingSection';
import { LanguageSection } from './settings/LanguageSection';
import { PasswordSection } from './settings/PasswordSection';
import { ProfileSection } from './settings/ProfileSection';
import { SettingsLink, SettingsSection } from './settings/parts';
import { StorageSection } from './settings/StorageSection';

export default function SettingsScreen() {
  const t = useT();
  const me = useRequiredMe();
  const installed = isStandalone();

  return (
    <Page title={t('settings.title')}>
      <div className="mx-auto flex max-w-2xl flex-col gap-8">
        <ProfileSection me={me} />
        <LanguageSection />
        <PasswordSection me={me} />
        <DrawingSection />
        <StorageSection />
        <MyAttendanceSection />
        <CalendarFeedSection />

        <SettingsSection icon={Info} title={t('settings.about')} id="settings-about">
          <div className="divide-y divide-[var(--line)]">
            <SettingsLink
              to="/install"
              icon={MonitorDown}
              title={t('settings.install')}
              desc={
                installed ? (
                  <span className="inline-flex items-center gap-1.5 text-[var(--ok-text)]">
                    <CheckCircle2 className="size-4" aria-hidden />
                    {t('settings.installed')}
                  </span>
                ) : (
                  t('settings.install_desc')
                )
              }
            />
            <SettingsLink to="/privacy" icon={ShieldCheck} title={t('settings.privacy')} desc={t('settings.privacy_desc')} />
            <div className="flex min-h-14 items-center justify-between gap-4 px-5 py-3">
              <span className="font-semibold">{t('settings.version')}</span>
              <span className="font-mono text-[15px] text-[var(--muted)] select-text">{__APP_VERSION__}</span>
            </div>
          </div>
        </SettingsSection>

        <AccountSection />
      </div>
    </Page>
  );
}
